/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import useWinRate from "../useWinRate";
// import themeConfig from "@/theme/theme.config"; // No longer needed directly
import { useTheme } from "@/context/ThemeContext"; // Import useTheme hook

export default function WinRateLineChart({ inputs }) {
  // build data points: vary r from 0.1→max, compute pMin via useWinRate
  const data = Array.from({ length: 20 }, (_, i) => {
    const rVal = 0.1 + (inputs.riskPerTrade * i) / 20; // This logic might need review for rVal generation
    const { pMin } = useWinRate({ ...inputs, riskPerTrade: rVal });
    return { risk: rVal, pMin };
  });

  const { colors } = useTheme(); // Get current theme's colors from context

  return (
    // Using ResponsiveContainer to make the chart adapt to its parent's size
    <ResponsiveContainer width="100%" height={200}>
      <LineChart data={data} margin={{ top: 5, right: 20, left: -20, bottom: 5 }}> {/* Adjusted margins */}
        <XAxis 
          dataKey="risk" 
          unit="%" 
          stroke={colors.textSecondary} 
          tick={{ fill: colors.textSecondary, fontSize: 12 }} 
        />
        <YAxis 
          domain={[0,100]} 
          unit="%" 
          stroke={colors.textSecondary} 
          tick={{ fill: colors.textSecondary, fontSize: 12 }} 
        />
        <Tooltip 
          formatter={(val) => `${val.toFixed(1)}%`} 
          contentStyle={{ 
            backgroundColor: colors.backgroundSurface, 
            borderColor: colors.borderDefault,
            borderRadius: '0.5rem', // Equivalent to rounded-lg
            color: colors.textPrimary // Default text color inside tooltip
          }}
          labelStyle={{ color: colors.textPrimary, marginBottom: '0.25rem', fontWeight: '600' }}
          itemStyle={{ color: colors.textPrimary }}
          cursor={{ stroke: colors.borderDefault, strokeDasharray: '3 3' }}
        />
        <Line type="monotone" dataKey="pMin" stroke={colors.primary} strokeWidth={2} dot={{ r: 4, fill: colors.primary }} activeDot={{ r: 6, stroke: colors.backgroundSurface, fill: colors.primary }} />
      </LineChart>
    </ResponsiveContainer>
  );
}
